/* eslint-disable camelcase */
import { Toast } from 'vant';
import $api from '@/request/api'; // 导入api接口

export function milliFormat(
  number,
  decimals,
  dec_point,
  thousands_sep,
  round_tag,
) {
  number = (`${number}`).replace(/[^0-9+-Ee.]/g, '');
  decimals = decimals || 2; // 默认保留2位
  dec_point = dec_point || '.'; // 默认是'.';
  thousands_sep = thousands_sep || ','; // 默认是',';
  round_tag = round_tag || 'round'; // 默认是四舍五入
  const n = !isFinite(+number) ? 0 : +number;
  const prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  const sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep;
  const dec = typeof dec_point === 'undefined' ? '.' : dec_point;
  let s = '';
  const toFixedFix = function (n, prec) {
    const k = Math.pow(10, prec);
    console.log();

    return (
      `${
        parseFloat(
          Math[round_tag](parseFloat((n * k).toFixed(prec * 2))).toFixed(
            prec * 2,
          ),
        )
          / k}`
    );
  };
  s = (prec ? toFixedFix(n, prec) : `${Math.round(n)}`).split('.');
  const re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, `$1${sep}$2`);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

export const formatNum = (num, isTel = 0) => {
  const count = 4;
  // eslint-disable-next-line no-param-reassign
  num = isTel ? `0${num}` : num;
  const patt = new RegExp(`\\d{${count}}`, 'g');
  // eslint-disable-next-line no-param-reassign
  num = num.replace(patt, ($0) => {
    console.log($0.length, $0);
    return `${$0} `;
  });
  // eslint-disable-next-line no-param-reassign
  num = isTel ? num.slice(1).trim() : num;
  return num;
};

export const rules = {
  borrowerIdentity: [
    {
      pattern: /(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      message: '身份证格式错误',
    },
  ],
  borrowerName: [
    {
      pattern: /^[\u4e00-\u9fa5]{2,20}$/,
      message: '请输入正确的姓名',
    },
  ],

  bankNumber: [
    {
      pattern: /^\d{8,30}$/,
      message: '请输入正确银行卡号',
    },
  ],
  legalPhone: [
    {
      pattern: /^(1)\d{10}$/,
      message: '请输入正确手机号',
    },
  ],
  phone: [
    { required: true, message: '请输入正确手机号', pattern: /\S/ },
    {
      pattern: /^1\d{10}$/,
      message: '请输入正确手机号',
    },
  ],
  taxNoForBindingCompany: [
    {
      pattern: /^[0-9a-zA-Z]{15,20}$/,
      message: '请输入正确的企业税号',
    },
  ],
  password: [
    {
      pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/,
      message: '密码必须为6-12位的数字和字母的组合',
    },
  ],
  type: [{ required: true, message: '不能为空', pattern: /\S/ }],
  captcha: [{ pattern: /^\d{6}$/, message: '请输入正确的短信验证码' }],
  captchaRequired: [{ required: true, pattern: /^\d{6}$/, message: '请输入正确的短信验证码' }],

  taxNo: [
    {
      pattern: /[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/,
      message: '请输入正确的企业税号',
    },
  ],
  // eslint-disable-next-line no-dupe-keys
  password: [
    {
      pattern: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/,
      message: '密码必须为6-12位的数字和字母的组合',
    },
  ],
  // eslint-disable-next-line no-dupe-keys
  type: [{ required: true, message: '不能为空', pattern: /\S/ }],
  companyName: [
    { message: '请输入正确的企业名称', pattern: /^[\d\D]{2,50}$/ },
  ],
  companyNameForBindingCompany: [
    {
      message: '请输入正确的企业名称',
      pattern: /^[\u4e00-\u9fa5A-Za-z0-9\(\)\（\）]{2,50}$/,
    },
  ],
};

export const regionMap = {
  全国: {
    全国: '999999',
  },
  'A-G': {
    安徽: '340000',
    北京: '110000',
    重庆: '500000',
    福建: '350000',
    广东: '440000',
    甘肃: '620000',
    广西: '450000',
    贵州: '520000',
  },
  'H-Q': {
    湖北: '420000',
    湖南: '430000',
    河北: '130000',
    河南: '410000',
    海南: '460000',
    黑龙江: '230000',
    吉林: '220000',
    江西: '360000',
    江苏: '320000',
    辽宁: '210000',
    内蒙古: '150000',
    宁夏: '640000',
    青海: '630000',
  },
  'S-Z': {
    上海: '310000',
    山东: '370000',
    四川: '510000',
    山西: '140000',
    陕西: '610000',
    天津: '120000',
    西藏: '540000',
    新疆: '650000',
    云南: '530000',
    浙江: '330000',
  },
};
// 判断如果是苹果手机的话，解决苹果手机的缓存问题
export function addressIphone() {
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  if (isiOS) {
    window.onpageshow = function (e) {
      if (e.persisted) {
        // setTimeout("refresh()",50)
        window.location.reload(true);
      }
    };
  }
}
// 解决微信更新版本后ios键盘收起后页面回显的问题
export function solveIosWeixin() {
  document.body.addEventListener('focusout', () => {
    // 软键盘收起的事件处理
    const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
  });
}

// 手机号正则
export function checkPhone(phone) {
  const mobile = /^(1)\d{10}$/;
  if (phone === '') {
    Toast({
      message: '手机号码不能为空',
    });
    return false;
  } if (!mobile.test(phone)) {
    Toast({
      message: '请填写正确的手机号码',
    });
    return false;
  }
  return true;
}
export const commonMap = {
  creditSuccessListStr: {
    0: '正常',
    1: '逾期',
    2: '结清',
  },
};

// 金额千分化数字且保留两位小数
export function toThousands(num) {
  return parseFloat(num)
    .toFixed(2)
    .replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
}

// 获取定位信息
const obtainLocationInfo = (data) => new Promise((resolve, reject) => {
  const {
    appId, timestamp, nonceStr, signature,
  } = data;
  try {
    window.wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId,
      timestamp,
      nonceStr,
      signature,
      jsApiList: ['getLocation'],
    });
    setTimeout(() => {
      window.wx.ready(() => {
        window.wx.getLocation({
          type: 'wgs84',
          // eslint-disable-next-line no-shadow
          success: (res) => {
            const { latitude } = res; // 纬度，浮点数，范围为90 ~ -90
            const { longitude } = res; // 经度，浮点数，范围为180 ~ -180。
            resolve([latitude, longitude]);
          },
          cancel: () => {
            reject();
            console.log('查看附件机器，首先要授权位置信息');
          },
          // eslint-disable-next-line no-shadow
          fail: (res) => {
            console.info(`ready getLocation fail=${JSON.stringify(res)}`);
            console.log('出现故障，请联系管理员');
          },
        });
        // eslint-disable-next-line no-shadow
        window.wx.error((res) => {
          console.log(res, '微信api 报错');
        });
      });
    }, 500);
  } catch (error) {
    reject();
    console.log('error', error);
  }
});
// 获取IP地址 微信配置
export const getIPaddressAndwechatAccessLocation = () => {
  const url = 'supermarket/v2/';
  $api.PublicPage.getWXConfig({
    requestUrl: decodeURIComponent(url),
  }).then((res) => {
    obtainLocationInfo(res.data).then((result) => {
      localStorage.setItem('latLng', JSON.stringify(result));
    });
  });
  fetch('https://api.ipify.org/').then((response) => response.text()).then((ip) => {
    localStorage.setItem('extranetIp', ip);
  });
};

